import { render } from "./BaseRating.vue?vue&type=template&id=12207f6a&scoped=true"
import script from "./BaseRating.vue?vue&type=script&lang=js"
export * from "./BaseRating.vue?vue&type=script&lang=js"

import "./BaseRating.vue?vue&type=style&index=0&id=12207f6a&scoped=true&lang=css"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12207f6a"]])

export default __exports__